export default __webpack_public_path__ + "static/11007-bed152c5e47b65828b3ebff2c6beeff7.jpg";